import RootLngRoute from './RootLngRoute';

export default RootLngRoute;
